
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorPistonInleftBottom50 as ObiThreewayAcuatorPistonInleftBottom50Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-piston-inleft-bottom-50.js';
 
 
 

 
 export const ObiThreewayAcuatorPistonInleftBottom50 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-piston-inleft-bottom-50',
   elementClass: ObiThreewayAcuatorPistonInleftBottom50Element,
   events: {
     
   }
  });
 
 